function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Search");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-447.000000, -55.000000)",
  fill: "#636363"
}, React.createElement("path", {
  d: "M457.007318,60.195472 L456.371755,60.195472 L456.150829,60.4147847 C456.931275,61.3248528 457.405946,62.5046595 457.405946,63.7973243 C457.405946,66.6708021 455.076615,69 452.202973,69 C449.329331,69 447,66.6708021 447,63.7973243 C447,60.9238465 449.329331,58.5946487 452.202973,58.5946487 C453.495712,58.5946487 454.674786,59.0684924 455.584906,59.8480933 L455.805832,59.6287805 L455.805832,58.9948545 L459.806518,55 L461,56.1934138 L457.007318,60.195472 L457.007318,60.195472 Z M452.090909,60.0909091 C449.981576,60.0909091 448.272727,61.7997576 448.272727,63.9090909 C448.272727,66.0175758 449.981576,67.7272727 452.090909,67.7272727 C454.199394,67.7272727 455.909091,66.0175758 455.909091,63.9090909 C455.909091,61.7997576 454.199394,60.0909091 452.090909,60.0909091 L452.090909,60.0909091 Z",
  id: "Shape",
  transform: "translate(454.000000, 62.000000) scale(-1, -1) translate(-454.000000, -62.000000) "
})));

const SvgSearch = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.f5fdf943.svg";
export { ForwardRef as ReactComponent };